import {
  DescriptionLineFragment,
  ImageFragment,
  ItemTypeFragment,
  PhysicalPropertiesFragment,
  PolicyFragment,
  SubscriptionOptionInfoFragment,
} from '../../../../gql/graphql';
import {DescriptionLineModel} from './DescriptionLine.model';
import {ImageModel} from './Image.model';
import {PolicyModel} from './Policy.model';
import {ItemTypeModel} from './ItemType.model';
import {PhysicalPropertiesModel} from './PhysicalProperties.model';
import {SubscriptionInfoModel} from './SubscriptionInfo.model';
import {mapNullToUndefined} from '../../../utils/mapperHelper.utils';
import {ItemAttributes} from '@wix/auto_sdk_ecom_cart-v-2';

export class AttributesModel {
  public descriptionLines: DescriptionLineModel[];
  public image?: ImageModel;
  public policies?: PolicyModel[];
  public itemType: ItemTypeModel;
  public physicalProperties: PhysicalPropertiesModel;
  public subscriptionInfo?: SubscriptionInfoModel;
  public membersOnly?: boolean;

  constructor(params: AttributesModel) {
    this.descriptionLines = params.descriptionLines;
    this.image = params.image;
    this.policies = params.policies;
    this.itemType = params.itemType;
    this.physicalProperties = params.physicalProperties;
    this.subscriptionInfo = params.subscriptionInfo;
    this.membersOnly = params.membersOnly;
  }

  public static fromCheckoutV1({
    name,
    itemType,
    descriptionLines,
    image,
    policies,
    physicalProperties,
    subscriptionOptionInfo,
    membersOnly,
  }: {
    name: string;
    itemType: ItemTypeFragment;
    descriptionLines?: (DescriptionLineFragment | null)[] | null;
    image?: ImageFragment | null;
    policies?: (PolicyFragment | null)[] | null;
    physicalProperties?: PhysicalPropertiesFragment | null;
    subscriptionOptionInfo?: SubscriptionOptionInfoFragment | null;
    membersOnly?: boolean | null;
  }) {
    return new AttributesModel({
      descriptionLines: DescriptionLineModel.fromCheckoutV1ToList(descriptionLines),
      image: ImageModel.fromCheckoutV1(name, image),
      policies: (policies ?? []).map((policy) => PolicyModel.fromCheckoutV1(policy)),
      itemType: ItemTypeModel.fromCheckoutV1(itemType),
      physicalProperties: PhysicalPropertiesModel.fromCheckoutV1(physicalProperties),
      subscriptionInfo: SubscriptionInfoModel.fromCheckoutV1(subscriptionOptionInfo),
      membersOnly: mapNullToUndefined(membersOnly),
    });
  }

  public static fromCartV2(attributes: ItemAttributes, name: string): AttributesModel {
    return new AttributesModel({
      descriptionLines: DescriptionLineModel.fromCartV2ToList(attributes.descriptionLines),
      image: ImageModel.fromCartV2(name, attributes.image),
      policies: (attributes.policies ?? []) /* istanbul ignore next */
        .map(/* istanbul ignore next */ (policy) => /* istanbul ignore next */ PolicyModel.fromCartV2(policy)),
      itemType: ItemTypeModel.fromCartV2(attributes.itemType!),
      physicalProperties: PhysicalPropertiesModel.fromCartV2(attributes.physicalProperties!),
      subscriptionInfo: SubscriptionInfoModel.fromCartV2(attributes.subscriptionInfo),
      membersOnly: mapNullToUndefined(attributes.membersOnly),
    });
  }
}
